/** to be replaced by compiler during build time */
export default 'v0.2.0-beta.17';
